var map = {
	"./ALLERGEN_1.png": 3970,
	"./ALLERGEN_10.png": 6332,
	"./ALLERGEN_11.png": 3993,
	"./ALLERGEN_12.png": 8220,
	"./ALLERGEN_13.png": 1627,
	"./ALLERGEN_14.png": 6546,
	"./ALLERGEN_2.png": 4266,
	"./ALLERGEN_3.png": 530,
	"./ALLERGEN_4.png": 7603,
	"./ALLERGEN_5.png": 4063,
	"./ALLERGEN_6.png": 2895,
	"./ALLERGEN_7.png": 784,
	"./ALLERGEN_8.png": 9578,
	"./ALLERGEN_9.png": 7293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7257;